<template>
	<div class="pages">
		<section class="fx filter-list">
			<div class="fx fx-wrap fx-fill">
				<z-select :options="statusItems" class="w150" v-model="params.status" @handleChange="handleOffset(0)"></z-select>
				<!--<div class="fx fx-wrap m-l-10">
					<el-date-picker type="daterange" align="left" placeholder="选择日期范围(默认所有)">
					</el-date-picker>
				</div>-->
			</div>
			<div class="fx fx-wrap fx-fill"></div>
			<z-search v-model="params.search" placeholder="请输入微信昵称" @handleSearch="handleOffset(0)"></z-search>
		</section>
		<div id="list">
			<z-table :offset="params.offset" :count="params.count" :total-count="recordList.item_total" @handleOffset="handleOffset">
				<th slot="columns" v-for="(index, item) in columns">
					{{index}}
				</th>
				<tr slot="datasource" v-for="item in recordList.list || []">
					<td>{{item.nickname}}</td>
					<td><img :src="item.headimgurl" /></td>
					<td>{{item.total_fee | filterMoney}}</td>
					<td>{{item.pay_fee | filterMoney}}</td>
					<td>{{item.envelope_fee | filterMoney}}</td>
					<td>
						<span v-if="item.status == 1">已领取</span>
						<span v-else>已使用</span>
					</td>
					<td>{{item.l_time | momentFmt}}</td>
					<!--<td class="operating">
					<a class="operat-btn"><i class="icon-look"></i><span>详情</span></a>
				</td>-->
				</tr>
			</z-table>
		</div>
	</div>
</template>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	table img {
		width: 50px;
	}
	.pages {
		background: #FFFFFF;
		border: 1px solid #EBEDEE;
    		border-bottom: none;
		.filter-list {
			padding: 1rem;
		}
	}
	
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages {
			min-width: px-em(1100px);
		}
	}
</style>
<script>
	import { mapState, mapActions } from 'vuex'
	export default {
		name: 'RedPackedRecordPage',
		components: {},
		data() {
			return {
				columns: ['昵称', '头像', '订单金额', '支付金额', '红包金额', '状态', '修改时间'],
				params: {
					offset: 0, //分页偏移量
					count: 10, //每页多少条
					search: '',
					status: '',
					orderTime: ''
				},
				statusItems: [{
					value: '',
					text: '查看所有'
				}, {
					value: 1,
					text: '已领取'
				}, {
					value: 2,
					text: '已使用'
				}]
			}
		},
		computed: {
			...mapState({
				recordList: state => state.envelope.envelopeRecordList
			})
		},
		mounted() {
			this.handleInit();
		},
		methods: {
			//处理分页
			handleOffset(offset) {
				this.params.offset = offset;
				this.handleInit();
			},

			async handleInit() {
				await this.getEnvelopeRecordList(this.params);
				this.$log('获取记录成功');
			},
			...mapActions(['getEnvelopeRecordList']),
		}
	}
</script>


// WEBPACK FOOTER //
// RedPacketRecordPage.vue?37730417